import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'price',
  standalone: true,
})
export class PricePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) public locale: string) {}

  /**
   *
   * @param price
   */
  transform(price: number): string {
    if (!price) {
      return '';
    }

    const isVeryLarge = Math.abs(price) > 10_000_000;
    const isVerySmall = Math.abs(price) < 0.00001 && price !== 0;

    if (isVeryLarge || isVerySmall) {
      return price.toExponential(4);
    }

    const integerPartString = String(Math.trunc(Math.abs(price)));
    const integerDigits = integerPartString.length;

    const fractionDigits = Math.max(0, 8 - integerDigits);

    return price.toLocaleString('en-US', {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
      useGrouping: true,
    });
  }
}
